
import React, { Fragment, useState, useEffect } from "react";

import {
    TablePagination,
    TableContainer,
    TableRow,
    TableHead,
    TableCell,
    TableBody,
    Table,
    Paper,
    Box,
    CircularProgress,
    TextField,
    Toolbar,
    InputBase

} from "@material-ui/core";
import { alpha, makeStyles } from '@material-ui/core/styles';
import DeleteForeverOutlinedIcon from "@material-ui/icons/DeleteForeverOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { useStyles } from "./../../styles/style";
import { Link } from 'react-router-dom';
import axios from 'axios';
import cogoToast from 'cogo-toast';
import SearchIcon from '@material-ui/icons/Search';
import DeleteModal from "../Reusable/deleteModal";




export default function ListBanner(props) {

    const classes = useStyles();
    // const inClasses = cssStyles()
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState([]);
    const [searched, setSearched] = useState("");
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState("")
    
    const toggle = () => setDeleteModal(!deleteModal);
    const deleteEvent = async (id) => {
        await axios.delete(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/banner/${deleteId}`).then(
            res => {
                if(res.data.message == "success"){
                    let newData = data.filter(ele => {
                        return ele._id !== deleteId;
                    });
                    setData(newData);
                    setDeleteId("")
                }else{
                    cogoToast.error(res.data.message,{
                        hideAfter: 5, // Duration in seconds
                      })
                }
            }
        ).catch(err => {
            console.log(err);
        })
    }


    const fetchBanner = async () => {
        await axios.get(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/banner?storeId=${localStorage.getItem("storeId")}`)
            .then(

                res => {
                    // let object = res.data.result.filter(ele => {
                    //     ele.title = JSON.parse(ele.title)
                    //     return ele
                    // })
                    // console.log('obj->',object)
                    setData(res.data.result)
                }
            ).catch(
                err => {
                    console.log(err);
                }
            )
    }

    useEffect(() => {
        fetchBanner()
    }, [])

    const searchBanner = async (data) => {
        await axios.get(`${process.env.REACT_APP_CMS_PLAYLIST_IP}/v1/banner/search/${data}?storeId=${localStorage.getItem("storeId")}`)
            .then(
                res => {
                    
                    setData(res.data.result)
                }
            ).catch(
                err => {
                    console.log(err);
                }
            )
    }

    useEffect(() => {
        if (searched === "") {
            fetchBanner()
        }
    }, [searched])

    const searchContent = (e) => {
        if(e.key==="Enter"){
            searchBanner(searched)
        }
        
    }

    const handleChangePage = (event, newPage) => {
        setPagination(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPagination(0);
    };
    return (
        <Fragment>
            <Paper component={Box} p={4}>
                <Toolbar>
                    <h1>List Banners</h1>
                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <InputBase
                            placeholder="Search…"
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            value={searched}
                            onChange={(e) => setSearched(e.target.value)}
                            inputProps={{ 'aria-label': 'search' }}
                            onKeyDown={(e) => searchContent(e)}
                        />
                    </div>

                </Toolbar>


                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Id</TableCell>
                                <TableCell>CMS name</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Content Type</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>User</TableCell>
                                <TableCell>Trailer</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isLoading == true ? <CircularProgress /> :
                                data && data.length > 0 ? data
                                    .slice(pagination * rowsPerPage, (pagination + 1) * rowsPerPage)
                                    .map((emp, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{emp._id}</TableCell>
                                            <TableCell>{emp.cms_name}</TableCell>
                                            <TableCell>{emp.title}</TableCell>
                                            <TableCell>{emp.contentType}</TableCell>
                                            <TableCell>{emp.type}</TableCell>
                                            <TableCell>{emp.user == "2" ? "Both" : (emp.user == "1" ? "Pro User" : "Free User")}</TableCell>
                                            <TableCell align="center">{emp.playTrailer === true ? <span className="greendot"></span> : <span className="reddot"></span>}</TableCell>
                                            <TableCell>
                                                <Link to={`/editBanner/${emp._id}`}><EditOutlinedIcon className={classes.btnedit} /></Link>
                                                <DeleteForeverOutlinedIcon
                                                    className={classes.btndelete}
                                                    onClick={() => { setDeleteId(emp._id); toggle() }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )) : <p className="mt-2 text-center">no data</p>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 15, 50, 100]}
                        component="div"
                        count={data ? data.length : null}
                        rowsPerPage={rowsPerPage}
                        page={pagination}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                </TableContainer>
                <DeleteModal
                    toggle={toggle}
                    deleteModal={deleteModal}
                    deleteContent={deleteEvent}
                />
            </Paper>
        </Fragment>
    );

}
